import "bootstrap-icons/font/bootstrap-icons.css";
import "./Footer.css";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-wrapper">
      <div className="py-4">
        <div className="row text-center text-md-start">
          <div className="col-md-4 mb-3">
            <h5 className="fw-bold">Slide Para Missa</h5>
            <p className="small">
              Ferramentas para liturgia e celebrações católicas.
            </p>
          </div>
          <div className="col-md-4 mb-3">
            <h5 className="fw-bold">Links Úteis</h5>
            <ul className="list-unstyled small">
              <li>
                <a
                  href="/sobre"
                  className="text-light text-decoration-none small"
                >
                  Sobre
                </a>
              </li>
              <li>
                <a
                  href="/politica-privacidade"
                  className="text-light text-decoration-none small"
                >
                  Política de Privacidade
                </a>
              </li>
              <li>
                <a
                  href="/termos-de-uso"
                  className="text-light text-decoration-none small"
                >
                  Termos de Uso
                </a>
              </li>
              <li>
                <a
                  href="/politica-cookies"
                  className="text-light text-decoration-none small"
                >
                  Política de Cookies
                </a>
              </li>
              <li>
                <a
                  href="/contatos"
                  className="text-light text-decoration-none small"
                >
                  Contato
                </a>
              </li>
            </ul>
          </div>
          <div className="col-md-4 mb-3">
            <h5 className="fw-bold">Siga-nos</h5>
            <div>
              <a
                href="https://facebook.com"
                className="text-light me-3"
                aria-label="Facebook"
              >
                <i className="bi bi-facebook fs-4"></i>
              </a>
              <a
                href="https://instagram.com"
                className="text-light me-3"
                aria-label="Instagram"
              >
                <i className="bi bi-instagram fs-4"></i>
              </a>
              <a
                href="https://youtube.com"
                className="text-light"
                aria-label="YouTube"
              >
                <i className="bi bi-youtube fs-4"></i>
              </a>
            </div>
          </div>
        </div>
        <hr className="border-light" />
        <div className="text-center small">
          <p>
            &copy; {currentYear} Slide Para Missa. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
